module.exports = __webpack_public_path__ + "img/hero-sp.af1a40d4.jpg";